import React, { useState, useEffect } from 'react'
//import { useAlert } from 'react-alert'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import { GetApi } from '../../../Common/ApiAxios'

import MaterialHandling from '../Atoms/MaterialHandlingPrediction'

const DefaultUrl = '/api/logisticManagement'

const Flex = styled.div`
  display: flex; /* 横並び */
  flex-wrap: wrap;
  width: 100%;
  height: 130x;
  margin-top: 10px;
  margin-bottom: 10px;
`

const Content = styled.div`
  display: grid;
  grid-gap: 20px;
  grid-template-columns: 1fr;
  width: 90%;
  height: ${props => props.height ? props.height : '200px'};
  margin-left: 5%;

  ::-webkit-scrollbar-corner {
    display: none;
  }
`

// ヘッダー部のカード
const OperationHeader = (props) => {
  const {
    grants,
    dates,
    type,/*2023/12/25 K.Harada ADD typeを追加*/
    quantity
  } = props
  
  // 描画時に一度だけ実行
  useEffect(() => {
  }, [])

  if (!quantity || quantity == null) return null
  return (
    <Flex>
      <Content height={'130px'}>
        <MaterialHandling type={type}/>
      </Content>
    </Flex>
  )
}

OperationHeader.propTypes = {
  grants: PropTypes.object, // 権限関連
  dates: PropTypes.array, // 日付情報(1週分)
}
  
export default OperationHeader

